import { useDailyEvent, useLocalSessionId } from '@daily-co/daily-react';
import { useCallback, useState } from 'react';
import { UserMediaError } from '../UserMediaError/UserMediaError';
import { CameraDailyVideo, ScreenDailyVideo, VideoWrapper } from './VideoFeeds.styles';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';

export function VideoFeeds({ isScreenShareOn }: { isScreenShareOn: boolean }) {
  /* If a participant runs into a getUserMedia() error, we need to warn them. */
  const [getUserMediaError, setGetUserMediaError] = useState(false);

  /* We can use the useDailyEvent() hook to listen for daily-js events. Here's a full list
   * of all events: https://docs.daily.co/reference/daily-js/events */
  useDailyEvent(
    'camera-error',
    useCallback(() => {
      setGetUserMediaError(true);
    }, []),
  );

  /* This is for displaying our self-view. */
  const localSessionId = useLocalSessionId();

  const renderCallScreen = () => (
    <ErrorBoundary componentName="VideoFeed">
      <VideoWrapper>
        <div>
          <ScreenDailyVideo
            type={'screenVideo'}
            sessionId={localSessionId}
            $isScreenShareOn={isScreenShareOn}
          />
          <CameraDailyVideo
            automirror
            type={'video'}
            sessionId={localSessionId}
            $isScreenShareOn={isScreenShareOn}
          />
        </div>
      </VideoWrapper>
    </ErrorBoundary>
  );

  return getUserMediaError ? <UserMediaError /> : renderCallScreen();
}
